import { ProCard } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { EntityDeleteButton } from '@app/icare/components/entity/EntityDeleteButton'
import { EntityDeletedBanner } from '@app/icare/components/entity/EntityDeletedBanner'
import { CostCarrierId } from '@app/icare/entities/costCarrier/schema/CostCarrier'
import { useEntityDeletion } from '@app/icare/hooks/useEntityDeletion'
import { t } from '@lingui/core/macro'
import { zodParams } from '@pkg/db/utils'
import { useRouterTabs } from '@pkg/ui/hooks'
import { usePageContainerOverride } from '@pkg/ui/layout/PageContainerRuntime'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Tabs } from 'antd'
import { z } from 'zod'

export const Route = createFileRoute('/_app/kostentrager/$id')({
  component: RouteComponent,
  params: zodParams(z.object({ id: CostCarrierId.ref })),
  loader: () => ({
    breadcrumb: {
      label: t`Kostenträger`,
      to: '/kostentrager',
    },
  }),
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))
  const deletion = useEntityDeletion({ data, entityType: 'costCarriers' })
  const title = data?.name || 'Neuer Eintrag'
  const tabs = useRouterTabs()

  usePageContainerOverride(
    {
      header: {
        title,
        extra: <EntityDeleteButton {...deletion} />,
        footer: (
          <Tabs
            {...tabs}
            items={[
              {
                key: `/kostentrager/${params.id}`,
                label: 'Allgemein',
              },
              {
                key: `/kostentrager/${params.id}/contact-persons`,
                label: 'Ansprechpartner',
              },
              {
                key: `/kostentrager/${params.id}/ik-numbers`,
                label: 'IK-Nummern',
              },
            ]}
          />
        ),
      },
    },
    [title, tabs.activeKey, deletion.isDeleted, deletion.isPending],
  )

  if (!data) {
    return <ProCard loading />
  }

  return (
    <>
      <EntityDeletedBanner {...deletion} />
      <Outlet />
    </>
  )
}
